<template>
  <PostEvent v-if="isPostEvent" />
  <PreEvent v-else />
</template>

<script setup>
import useEventState from "@/composables/useEventState";
import PreEvent from "./PreEvent.vue";
import PostEvent from "./PostEvent.vue";
const {isPostEvent} = useEventState();
</script>
